module.exports = __webpack_public_path__ + "static/axo_freiraume_mini-e380fb968161e6a40ff49cf6056f1562.png";